<!--  -->
<template>
  <div class="card_wrap" style="">
    <div class="header_wrap">
      <p class="header_p">
        分区方案设置<el-divider direction="vertical"></el-divider>
      </p>
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="分区方案名称">
          <el-input v-model="formInline.regionName"></el-input>
        </el-form-item>
        <el-form-item label="所属国家">
          <el-select clearable v-model="formInline.countryId">
            <el-option v-for="item in countAll" :key="item.id" :label="item.namec" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="分区信息">
          <el-input v-model="formInline.regionDetail"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getShowcount()">查询</el-button>
        </el-form-item>
      </el-form>
      <el-button type="success" @click="addFrom()">新增</el-button>
    </div>
    <div class="Center_wrap">
      <template>
        <el-table size="mini" max-height="700px" tooltip-effect="dark" :header-cell-style="{ background: '#F3F3F3' }" ref="multipleTable" border :data="tableData" style="width: 100%">
          <el-table-column type="index" align="center" label="序号" width="50">
          </el-table-column>
          <el-table-column align="center" prop="regionName" label="分区方案名称" width="180">
          </el-table-column>
          <el-table-column align="center" prop="country" label="所属国家">
          </el-table-column>
          <el-table-column align="center" prop="regionDetail" label="分区信息">
          </el-table-column>
          <el-table-column align="center" prop="remarks" label="备注">
          </el-table-column>
          <el-table-column align="center" prop="inputer" label="录入人">
          </el-table-column>
          <el-table-column align="center" prop="inputTime" label="录入时间">
          </el-table-column>
          <el-table-column label="操作" align="center" width="180">
            <template slot-scope="scope">
              <el-button size="mini" type="warning" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
              <el-button slot="reference" size="mini" @click="handleDelete(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </template>
    </div>
    <div class="TB_center" style="width: 100%; margin-top: 50px">
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" layout="prev, pager, next" :total="countlisttotal"></el-pagination>
    </div>
    <!-- 新增 -->
    <el-dialog width="800px" center title="分区方案设置" :visible.sync="dialogFormVisible">
      <el-form label-position="left" :inline="true" :model="createOrform">
        <el-form-item label="分区方案名称" :rules="[{ required: true, message: '不能为空' }]" label-width="110px">
          <el-input v-model="createOrform.regionName" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item :rules="[{ required: true, message: '不能为空' }]" label="所属国家">
          <el-select v-model="createOrform.countryId" @change="changeCity(createOrform.countryId)">
            <el-option v-for="item in countAll" :key="item.id" :label="item.namec" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <div style="float: left; width: 100%">
          <el-form-item label="备注" label-width="110px">
            <el-input v-model="createOrform.remark" autocomplete="off"></el-input>
          </el-form-item>
        </div>
      </el-form>
      <div style="
          width: 100%;
          float: left;
          display: flex;
          justify-content: center;
          margin-bottom: 30px;
        ">
        <el-transfer filterable :titles="['未选择', '已选择']" :filter-method="filterMethod" filter-placeholder="请输入城市拼音" v-model="checkedCitylist" :props="{
            key: 'id',
            label: `namec`,
          }" :data="cityList">
        </el-transfer>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="setQd()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import qs from "qs";
export default {
  components: {},
  data () {
    return {
      pageNum: 1,
      countlisttotal: 0,
      countAll: [],
      cityList: [],
      checkedCitylist: [],
      filterMethod (query, item) {
        return item.namec.indexOf(query) > -1;
      },
      createOrform: {
        regionName: "",
        countryId: "",
        remark: "",
      },
      dialogTableVisible: false,
      dialogFormVisible: false,
      formInline: {
        regionDetail: "",
        countryId: "",
        regionName:''
      },
      tableData: [],
    };
  },
  computed: {},
  watch: {},
  methods: {
    handleDelete (item) {
      let that = this;
      this.$confirm("确定删除该数据吗, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.axios
            .get(`/carrier/region/deleteCarrierRegion/${item.id}`)
            .then((res) => {
              if (res.data.code !== 200) {
                return this.$message.info(res.data.message||"服务器繁忙");
              }
              this.getShowcount();
            })
            .catch(function (error) {
              console.log(error);
            });
        })
        .catch(() => {
          that.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    handleEdit (index, item) {
      console.log(item);
      this.createOrform.countryId = item.countryId;
      this.changeCity(item.countryId);
      this.checkedCitylist = item.cityIdList;
      this.createOrform.regionName = item.regionName;
      this.dialogFormVisible = true;
      this.itemID = item.id;
    },
    setQd () {
      console.log(this.checkedCitylist);
      if (this.checkedCitylist.length <= 0)
        return this.$message("请分配所需城市");
      if (!this.createOrform.regionName)
        return this.$message("请填写分区方案名称");
      let params = {
        cityList: this.checkedCitylist,
        countryId: this.createOrform.countryId,
        id: this.itemID,
        regionName: this.createOrform.regionName,
        remark: this.createOrform.remark,
      };
      this.axios
        .post("/carrier/region/createOrUpdateCarrierRegion", params)
        .then((res) => {
          console.log(res);
          if (res.data.code !== 200) {
            this.cityList = [];
            return this.$message.info(res.data.message||"服务器繁忙");
          }
          this.dialogFormVisible = false;
          this.pageNum = 1;
          this.getShowcount();
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    changeCity (id) {
      //切换城市
      this.getcityAll(id);
    },
    getcityAll (id) {
      this.axios
        .get(`/filedata/findCountryCityAll/${id}`)
        .then((res) => {
          if (res.data.code !== 200) {
            this.cityList = [];
            return this.$message.info(res.data.message||"服务器繁忙");
          }
          this.cityList = res.data.datas;
          console.log(this.cityList);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    geicountAll () {
      //获取所有国家
      this.axios
        .get("/filedata/findCountryAll")
        .then((res) => {
          if (res.data.code !== 200) {
            this.countAll = [];
            return this.$message.info(res.data.message||"服务器繁忙");
          }
          this.countAll = res.data.datas;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    handleSizeChange (val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange (val) {
      console.log(`当前页: ${val}`);
      this.pageNum = val;
      this.getShowcount();
    },
    getShowcount () {
      //查询列表数据
      let params = {
        countryId: this.formInline.countryId,
        pageNum: this.pageNum,
        pageSize: 20,
        regionDetail: this.formInline.regionDetail,
        regionName:this.formInline.regionName,
      };
      this.axios
        .post("/carrier/region/getCarrierRegionList", params)
        .then((res) => {
          console.log(res);
          if (res.data.code !== 200) {
            this.tableData = [];
            this.countlisttotal = 10;
            return this.$message.info(res.data.message||"服务器繁忙");
          }
          this.tableData = res.data.data.list;
          this.countlisttotal = res.data.data.total;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    addFrom () {
      this.dialogFormVisible = true;
      this.checkedCitylist = [];
      this.itemID = "";
      this.createOrform.regionName = "";
    },
  },

  created () { },
  mounted () {
    this.geicountAll();
    this.getShowcount();
  },
};
</script>
<style  scoped>
.TB_center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.card_wrap {
  padding: 30px;
  background: rgb(255, 255, 255);
  box-shadow: rgb(107 105 105 / 21%) 0px 0px 20px 0px;
  border-radius: 10px;
}
.header_p {
  font-size: 30px;
  font-weight: bold;
  padding-bottom: 35px;
}
.Center_wrap {
  margin-top: 35px;
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
</style>



// WEBPACK FOOTER //
// src/components/QuotationManagement/partition.vue